export default __webpack_public_path__ + "static/media/rmall-project-3.03b46a9a.webp";